import * as Sentry from '@sentry/react';

import { vnextApiClient } from '@/services/vnext-api';
import { useLeaderPoll } from './useLeaderPoll';

const COUNT_POLL_MS = 30_000;

/** Tab-channel key the leader shares the count under (see `useLeaderPoll`). */
export const INBOX_COUNT_POLL_KEY = 'inbox-count';

/**
 * The nav badge's needs-you count — polled slowly (the endpoint is a
 * single indexed COUNT, but the badge doesn't need queue-speed
 * freshness). `null` until the first value lands; errors keep the last
 * known value rather than flashing the badge away.
 *
 * Mounted in the shell of every admin tab, so it runs through the
 * leader poll: one tab fetches, the rest receive the value.
 */
export function useInboxCount(enabled: boolean): number | null {
  const { data } = useLeaderPoll<number>(INBOX_COUNT_POLL_KEY, {
    enabled,
    interval: COUNT_POLL_MS,
    queryFn: ({ signal }) => vnextApiClient.getInboxCount({ signal }),
    onError: (error) => Sentry.captureException(error),
  });
  return data ?? null;
}
